const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true,
    width: 200
  },
  {
    prop: 'description',
    label: 'Status',
    sortable: true,
    width: 350
  },
  {
    prop: 'status',
    label: 'Status',
    sortable: true
  }
];

const tableFilters = [
  //   {
  //     label: 'Inactive',
  //     name: 'inactive',
  //     search: 'status',
  //     param: 'pending'
  //   },
  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  }
  //   {
  //     label: 'Recent activity',
  //     name: 'activity',
  //     search: 'lastLogin',
  //     param: '' // TODO timestamp
  //   }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions };
